// Resolves brand logos (AI providers, data adapters, email providers) to static
// asset URLs under /public/img. Any block that carries a data adapter, AI
// provider or email provider — the agent itself included — shows its logo.
//
// All resolvers are defensive: an unknown / unset key returns null so the caller
// can simply fall back to the block's monochrome icon.
import { DATA_ADAPTER_ICONS, DATA_ADAPTERS } from '@/constants';

// AI provider registry key -> /img/providers asset. Keys mirror the values stored
// on `agent.provider` (see availableAIProviders). Lower-cased before lookup so
// casing differences between registry and storage don't matter.
const AI_PROVIDER_LOGOS = {
  openai: '/img/providers/openai.svg',
  azure: '/img/providers/azure.png',
  azure_openai: '/img/providers/azure.png',
  anthropic: '/img/providers/claude.png',
  claude: '/img/providers/claude.png',
  google: '/img/providers/gemini.webp',
  gemini: '/img/providers/gemini.webp',
  google_gemini: '/img/providers/gemini.webp',
  perplexity: '/img/providers/perplexity.png',
  cloudflare: '/img/providers/cloudflare.png',
};

// Email provider key -> /img/providers asset (matches EmailProviders.vue).
const EMAIL_PROVIDER_LOGOS = {
  AWS_SES: '/img/providers/AWS_SES.png',
  SENDGRID: '/img/providers/SENDGRID.png',
};

export function aiProviderLogo(provider) {
  if (!provider) return null;
  return AI_PROVIDER_LOGOS[String(provider).toLowerCase()] || null;
}

// `adapterType` is the adapter registry key (POSTGRESQL, MYSQL, ...). The
// constants map covers the curated set; otherwise fall back to the conventional
// /img/dataadapters/<lowercase>.png so newly added adapters still render.
export function dataAdapterLogo(adapterType) {
  if (!adapterType) return null;
  const key = String(adapterType).toUpperCase();
  return DATA_ADAPTER_ICONS[key] || `/img/dataadapters/${String(adapterType).toLowerCase()}.png`;
}

export function emailProviderLogo(provider) {
  if (!provider) return null;
  return EMAIL_PROVIDER_LOGOS[String(provider).toUpperCase()] || null;
}

// Friendly display name for a data adapter key (e.g. CLOUDFLARE_D1 -> "Cloudflare D1").
export function dataAdapterName(adapterType) {
  if (!adapterType) return '';
  const a = DATA_ADAPTERS[String(adapterType).toUpperCase()];
  return (a && a.name) || adapterType;
}
